import React from "react";
import { Navigate } from "react-router-dom";
import LandingPage from "../LandingPage";
import { isPublicSiteHostname } from "../../utils/helpers/tenantHost";

const TenantEntryPage = () => {
  const hostname = typeof window === "undefined" ? "" : window.location.hostname;

  return isPublicSiteHostname(hostname) ? <LandingPage /> : <Navigate replace to="/login" />;
};

export default TenantEntryPage;
